import './CloseIcon.scss'

interface Props {
  onClick: () => void
}

function CloseIcon({ onClick }: Props) {
  return <span className='close-icon' onClick={onClick} />
}

export default CloseIcon
